export const PRICING_COPY = {
  cta: {
    paywall: 'Unlock access',
    pricing: 'Choose plan',
    continueInNewWindow: 'Continue in new window',
    checkSubscriptionStatus: 'Check subscription status',
    freePlan: 'Continue free',
  },
  unlockDialog: {
    title: 'Unlock Direct Outreach',
    description:
      'Choose Guided Launch at $12.50/mo (billed annually) for guided expert support and everything in Campaign, or start with Campaign at $20/mo for auto-apply, auto-outreach, and self-serve access.',
  },
  pageHero: {
    lineOne: 'Your job search moves every day.',
    lineTwo: 'Decide how much',
    highlight: 'runs on its own',
  },
  pageFooter: {
    lead: 'Unlimited usage applies under normal usage conditions. Throughput may be moderated only for exceptionally high volume to keep performance stable for all members.',
    emphasis: 'This is fair-use protection, not a hard cap',
  },
} as const;
